export default "__VITE_ASSET__B20rWkf7__"